import {JsonProperty} from '../shared/decorators/json-property';

export class Profit {
  value: number;
  timestamp: number;
  time_: string;
  constructor() {
    this.value = undefined;
    this.timestamp = undefined;
    this.time_ = undefined;
  }
}

export class ProfitInfo {
  balance: number;
  profit: number;
  @JsonProperty('day_time')
  time: number;
  delta: number;
  percent: number;
  constructor() {
    this.balance = undefined;
    this.profit = undefined;
    this.time = undefined;
    this.delta = undefined;
    this.percent = undefined;
  }
}
